
































































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Decimal} from 'decimal.js'

import {CashoutData, Sku, SuggestedCashoutValue, ProductDenominationType, suggestNewCashoutValues, ProductAvailability} from "../models";
import {cashoutEventBus, CashoutEvents} from "../bus";
import {formatCurrency, ZERO} from "../util/number";

import SkuImage from "./SkuImage";

@Component({
    components: {
        SkuImage,
    }
})
export default class CashoutModalValueResolve extends Vue {
    @Prop()
    cashoutData!: CashoutData;
    selectingSku: Sku | null = null;
    stockSuggestions: SuggestedCashoutValue[] = [];
    formatCurrency = formatCurrency;

    mounted(): void {
        cashoutEventBus.$on(CashoutEvents.SKU_SELECT_ADJUSTMENT_REQUIRED, this.modalOpen);
    }

    modalOpen(sku: Sku) {
        this.selectingSku = sku;
        this.stockSuggestions = suggestNewCashoutValues(this.selectingSku, this.cashoutData);
        this.$modal.show('stock-select-modal');
    }

    modalClose() {
        this.$modal.hide('stock-select-modal');
    }

    modalOpened() {

    }

    modalClosed() {

    }

    adjustFiatValueAndSelect(fiatValue: Decimal) {
        if (!this.selectingSku) throw "No reference to sku";
        this.cashoutData.fiatAmount = fiatValue;
        cashoutEventBus.$emit(CashoutEvents.SKU_SELECT, this.selectingSku.id);
        this.modalClose();
    }

    get hasSuggestions(): boolean {
        return this.stockSuggestions.length > 0
    }

    get firstAvailableDenomination(): Decimal | undefined {
        if (!this.selectingSku) return undefined;
        if (this.selectingSku.availability === ProductAvailability.REALTIME)
            return this.selectingSku.minimumValue;
        if (!this.selectingSku.availableDenominations) return undefined;

        // Get available denominations filtered by a minimum
        let availableDenominations = this.selectingSku.filterAvailableDenominations(
            this.cashoutData.minFiatAmount || ZERO);

        if (!availableDenominations) return undefined;

        return availableDenominations[0]
    }

    get formattedMinFiatValue(): string {
        if (!this.selectingSku || !this.firstAvailableDenomination) return "";

        let minFiatValue = Decimal.max(this.cashoutData.minFiatAmount || ZERO,
            this.selectingSku.fiatValue(this.firstAvailableDenomination));

        return formatCurrency(minFiatValue, this.cashoutData.fiatCurrencyCode);
    }

    get limitedByMinFiatAmount(): boolean {
        // Are we limited by the global minFiatAmount or the product's min value?
        if (!this.selectingSku || !this.firstAvailableDenomination) return false;
        return (this.cashoutData.minFiatAmount || ZERO).gt(this.selectingSku.fiatValue(this.firstAvailableDenomination))
    }

    get formattedWalletBalanceAsFiat(): string {
        let walletBalanceAsFiat = this.cashoutData.walletBalanceAsFiat;
        if (!walletBalanceAsFiat) return "";
        return formatCurrency(walletBalanceAsFiat, this.cashoutData.fiatCurrencyCode)
    }
}
